export const Logo = ({ className = "h-10 w-auto", variant = "full" }) => (
  <img
    src={variant === "wordmark" ? "/wexoz-wordmark.png" : "/wexoz-logo.png"}
    alt="Wexoz Security & Surveillance LLC"
    className={`${className} select-none`}
    draggable="false"
  />
);

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M14 18h10l9 11-5 6z" fill="#1E7BFF" />
    <path d="M50 18H40l-9 11 5 6z" fill="#22C55E" />
    <path d="M14 46h10l9-11-5-6z" fill="#F43F5E" />
    <path d="M50 46H40l-9-11 5-6z" fill="#FACC15" />
  </svg>
);
